/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';
